export default __webpack_public_path__ + "79019f47c4489bfcb239981d25456778.woff";